import { useContext } from 'react';
import { Context } from '../contexts/SnackbarContext';

export default function useSnackbar() {
  const { show } = useContext(Context);
  return show;
}
